import Thunk from 'src/thunks/index';
import notification from 'src/store/ui/notification';

const user_issue = new Thunk('user_issues');

export const createIssue = user_issue.create<void, Partial<Model.UserIssue>>({
  onSuccess({ dispatch }) {
    dispatch(notification.on({ type: 'success', message: 'Issue reported!' }));
  },
});
